import CardHeader from "@commons/businesscardHeader";
import Button from "@components/button";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import { Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import generalSettings from "@apis/generalSettings";
import { toast } from "react-toastify";

const BusinessRule = () => {
  const [existing, setExisting] = useState<any | null>(null);
  const [initialValues, setInitialValues] = useState({
    defaultCharge: "",
    confirmBy: "store",
    countryPicker: false,
    showSubscription: false,
  });

  const fetchBusinessRules = useCallback(async () => {
    try {
      const data = await generalSettings.getByKey({
        id: "business-rules",
        state: "businessRules",
        showErr: false,
      });
      if (data) {
        setExisting(data);
        setInitialValues({
          defaultCharge: data?.infos?.defaultCharge ?? "",
          confirmBy: data?.infos?.confirmBy ?? "store",
          countryPicker: data?.infos?.countryPicker ?? false,
          showSubscription: data?.infos?.showSubscription ?? false,
        });
      }
    } catch (err) {
      console.error("Failed to fetch business rules", err);
    }
  }, []);

  useEffect(() => {
    fetchBusinessRules();
  }, [fetchBusinessRules]);

  const handleSubmit = async (values: any) => {
    const payload: any = {
      key: "business-rules",
      group: "business-settings",
      infos: {
        defaultCharge: values.defaultCharge,
        confirmBy: values.confirmBy,
        countryPicker: values.countryPicker,
        showSubscription: values.showSubscription,
      },
    };

    try {
      if (existing?.id) {
        await generalSettings.update({
          id: existing.id,
          state: "businessRules",
          data: payload,
        });
        toast.success("Business rules updated successfully!");
      } else {
        await generalSettings.create({
          state: "businessRules",
          data: payload,
        });
        toast.success("Business rules created successfully!");
      }
      fetchBusinessRules();
    } catch (err) {
      console.error("Failed to save business rules", err);
      toast.error("Failed to save business rules");
    }
  };

  return (
    <>
      <CardHeader title="Business Rule Setup" />
      <Wrapper>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <Row>
                <Fields.Input
                  name="defaultCharge"
                  label="Commission Rate On Delivery Charge (%)"
                  placeholder="e.g. 10"
                />
                <Fields.DropDown
                  name="confirmBy"
                  label="Who Will Confirm"
                  options={[
                    { key: "store", title: "Store" },
                    { key: "deliveryman", title: "Delivery Man" },
                  ]}
                  titleAsKey="title"
                  valueAsKey="key"
                  styleInput="width:97%"
                />
              </Row>
              <br />
              <Row>
                <Fields.Switch
                  name="countryPicker"
                  label="Country Picker"
                  onChange={(val) => setFieldValue("countryPicker", val)}
                  styleWrapper="flex-direction:row;justify-content:space-between"
                />
                <Fields.Switch
                  name="showSubscription"
                  label="Show Subscription"
                  onChange={(val) => setFieldValue("showSubscription", val)}
                  styleWrapper="flex-direction:row;justify-content:space-between"
                />
              </Row>
              <br />
              <Button
                type="submit"
                title={existing ? "Update" : "Save"}
                justify="end"
              />
            </Form>
          )}
        </Formik>
      </Wrapper>
    </>
  );
};

export default BusinessRule;
